@if (data.meta.IsModal) {
  <div class="modal-header">
    <div tabindex="0" ngbAutofocus class="modal-title h4">
      @if (externalLink) {
        <a href="{{ externalLink }}" target="_blank">
          {{ title }}
          <i class="fas fa-arrow-circle-right"></i>
        </a>
      }
      @if (internalLink) {
        <a href="{{ internalLink }}">
          {{ title }}
          <i class="fas fa-arrow-circle-right"></i>
        </a>
      }
      @if (!externalLink && !internalLink) {
        {{ title }}
      }
      @if (widgetSubtitle?.length > 0) {
        <span><small>({{ widgetSubtitle }})</small></span>
      }
      @if (showHelp) {
        <a (click)="sidebarService.openHelp({name:data.meta.Name,title:title})"><i class="widget-help fas fa-question-circle"></i></a>
      }
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <ng-container [ngTemplateOutlet]="content"></ng-container>
  </div>
} @else {
  @if (isVisible) {
    <div class="card" [ngClass]="{'chromeless': data.IsChromeless === true}">
      <div class="card-header">
        <div class="widget-settings">
          @if (data.IsBeta) {
            <span class="widget-settings-beta badge-light">
              BETA
            </span>
          }
          <button class="btn btn-link btn-xs widget-favorite" type="button" (click)="toggleFavorite()" aria-label="favorite">
            <i class="fa-star" [ngClass]="{'fas': data.IsFave, 'far': !data.IsFave}"></i>
          </button>
          <div class="btn-group widget-resize" role="group">
            <button type="button" class="btn btn-link" data-toggle="dropdown" aria-expanded="false" aria-label="expand">
              <i class="fas fa-expand"></i>
            </button>
            <div class="dropdown-menu">
              <div class="dropdown-item" (click)="resizeWidget(4)">Small</div>
              <div class="dropdown-item" (click)="resizeWidget(6)">Medium</div>
              <div class="dropdown-item" (click)="resizeWidget(12)">Large</div>
            </div>
          </div>
          <button type="button" class="btn btn-link drag-handle widget-move" aria-label="move">
            <i class="fas fa-arrows-alt"></i>
          </button>
          <button type="button" class="btn btn-link widget-collapse" data-toggle="collapse" (click)="toggleCollapse()" aria-label="collapse">
            <i class="far" [ngClass]="{'fa-window-maximize': data.IsCollapsed, 'fa-window-minimize': !data.IsCollapsed}"></i>
          </button>
        </div>
        <div class="float-left">
          <span class="widget-title">
            @if (externalLink) {
              <a href="{{ externalLink }}" target="_blank">
                {{ title }}@if (itemCount > 0) {
                <span class="badge badge-primary">{{itemCount}}</span>
              }
              @if (alertCount > 0) {
                <span class="badge badge-danger">{{alertCount}}</span>
              }
              <i class="fas fa-arrow-circle-right"></i>
            </a>
          }
          @if (internalLink) {
            <a href="{{ internalLink }}">
              {{ title }}@if (itemCount > 0) {
              <span class="badge badge-primary">{{itemCount}}</span>
            }
            @if (alertCount > 0) {
              <span class="badge badge-danger">{{alertCount}}</span>
            }
            <i class="fas fa-arrow-circle-right"></i>
          </a>
        }
        @if (!externalLink && !internalLink) {
          {{ title }}@if (itemCount > 0) {
          <span class="badge badge-primary">{{itemCount}}</span>
        }
        @if (alertCount > 0) {
          <span class="badge badge-danger">{{alertCount}}</span>
        }
      }
      @if (widgetSubtitle?.length > 0) {
        <span><small>({{ widgetSubtitle }})</small></span>
      }
      @if (showHelp) {
        <a (click)="sidebarService.openHelp({name:data.meta.Name,title:title})"><i class="widget-help fas fa-question-circle"></i></a>
      }
    </span>
  </div>
</div>
<div class="card-body" [ngClass]="{'collapse': data.IsCollapsed}">
  <ng-container [ngTemplateOutlet]="content"></ng-container>
</div>
</div>
}
}


<!--  You can only have one ng-content in the html file for it to work correctly even if you are calling it in different views  -->
<ng-template #content>
  <ng-content></ng-content>
</ng-template>
